class DropdownLinks extends HTMLElement {

    /** @type {HTMLButtonElement} */
    get trigger() {
		const trigger = this.querySelector('.dropdown-links__trigger');

		if (!(trigger instanceof HTMLButtonElement)) throw new Error('Trigger element not found');

		return trigger;
	}

    /** @type {HTMLElement} */
    get menu() {
		const menu = this.querySelector('.dropdown-links__menu');

		if (!(menu instanceof HTMLElement)) throw new Error('Menu element not found');

		return menu;
	}

    connectedCallback() {
        if (!this.trigger || !this.menu) return;

        this.trigger.addEventListener('click', () => { this.handleToggle() });
        document.addEventListener('click', (e) => { this.handleDocumentClick(e) });
        document.addEventListener('keydown', (e) => { this.handleKeydown(e) });
    }

    handleToggle() {
        const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * @param {MouseEvent} event
     */
    handleDocumentClick(event) {
        if (!this.contains(/** @type {Node} */ (event.target))) {
            this.close();
        }
    }

    /**
     * @param {KeyboardEvent} event
     */
    handleKeydown(event) {
        if (event.key === 'Escape') {
            this.close();
            this.trigger.focus();
        }
    }

    open() {
        this.menu.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
        this.menu.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
    }
}

if (!customElements.get('dropdown-links')) {
  	customElements.define('dropdown-links', DropdownLinks);
}
